export enum RETRO_PAGES {
  WELCOME = "/retrospectiva/2025",
  CO2 = "/retrospectiva/C02",
  RENEWABLES = "/retrospectiva/energia-verde",
  AUTOMATIONS = "/retrospectiva/automacao",
  ENVIRONMENTAL = "/retrospectiva/impacto-ambiental",
  ODS = "/retrospectiva/ODS",
  IMPACT = "/retrospectiva/seu-impacto",
}

export const RETRO_ORDER = [
  RETRO_PAGES.WELCOME,
  RETRO_PAGES.CO2,
  RETRO_PAGES.RENEWABLES,
  RETRO_PAGES.AUTOMATIONS,
  RETRO_PAGES.ENVIRONMENTAL,
  RETRO_PAGES.ODS,
  RETRO_PAGES.IMPACT,
];
